import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCn from './zh_cn'
import zhTc from './zh_tc'

Vue.use(VueI18n)

const messages = {
    zhCn,
    zhTc,
}

export const i18n = new VueI18n({
    locale: 'zhCn',
    fallbackLocale: 'zhCn',
    messages,
})

export default i18n
